module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16Ca48L/tc-custom/9781524850807.jpg?1728725488519",
      "alt": "This image is the cover for the book Identity Theft"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Identity Theft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Winner of the 2019 Silver Nautilus Book Award")]), _vm._v(", "), _c('i', [_vm._v("Identity Theft")]), _vm._v(" centers on Debra’s experience: her stroke, her extraordinary efforts to recover, and her journey to redefine herself. But she also draws on her skills as a social scientist, sharing stories from several dozen fellow survivors, family members, friends, colleagues, therapists, and doctors she has met and interviewed. By sharing this diversity of experiences, Debra highlights how every person is different, every stroke is different, and every recovery is different. She provides a valuable look at the broad possibilities for successfully navigating the challenging physical recovery—and the equally difficult emotional journey toward rebuilding one’s identity and a rewarding life after a trauma like stroke."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Debra Meyerson, Danny Zuckerman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0